<template>
    <div>
        <div class="d-flex justify-content-between">
            <div class="question-name">
                <i class="fa fa-file-circle-question"></i>
                <span>{{ questionData.name }}</span>
            </div>
            <div class="question-options d-flex">
                <button type="button" class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary"
                    alt="Eliminar pregunta" title="Eliminar" @click="deleteQuestion()">
                    <i class="fa-regular fa-trash-can"></i>
                </button>
            </div>
        </div>

        <div class="row mt-4">
            <div class="form-group">
                <label for="questiontypeinput">Tipo de pregunta</label>
                <select v-model="questionData.question_type" @change="onChangeTypeQuestion" id="questiontypeinput" class="form-control sin-borde rounded-8">
                    <option value="true_or_false">Verdadero o falso</option>
                    <option value="multi_choice">Opción múltiple</option>
                    <option value="single_choice">Opción única</option>
                </select>
            </div>
        </div>
        <div class="row mt-4">
            <div class="form-group">
                <label for="questioninput">Pregunta</label>
                <input v-model="questionData.question" type="text" class="form-control sin-borde rounded-8">
            </div>
        </div>
        <div class="row mt-4">
            <div class="form-group">
                <label for="questiondescriptioninput">Descripción</label>
                <textarea v-model="questionData.description" id="questiondescriptioninput" :rows="5" class="form-control sin-borde rounded-8"
                    placeholder="Descripción de la pregunta"></textarea>
            </div>
        </div>
        <div class="row mt-4">
            <div class="card answercard bg-transparent border-0">
                <div class="card-header d-flex justify-content-between">
                    <div class="card-header-tile">
                        <i class="fa fa-file-circle-question"></i>
                        <span>Respuestas</span>
                    </div>
                    <div>
                        <span>Respuesta correcta</span>
                    </div>
                </div>
                <div class="card-body bg-white">
                    <draggable v-model="questionData.answers" handle=".handle" :animation="200">
                        <transition-group>
                            <div class="answer-container my-3 d-flex" v-for="answer in questionData.answers" :key="answer.id">
                                <div class="drag-icon px-2 d-flex align-items-center py-3">
                                    <i class="fa fa-grip-vertical handle fa-2x"></i>
                                </div>
                                <div
                                    class="d-flex answer-content w-100 p-3 justify-content-between align-items-center bg-utel-v2-secondary">
                                    <div class="w-90">
                                        <input type="text" class="form-control sin-borde rounded-8" v-model="answer.text">
                                    </div>
                                    <div class="w-10">
                                        <input :type="typeQuestion" class="customradiobutton" v-model="questionData.answer" :value="answer.text">
                                    </div>
                                </div>
                                <div class="d-flex answer-action align-items-center py-3" v-if="questionData.question_type !== 'true_or_false'">
                                    <button class="btn p-1 rounded-pill text-primary" @click="deleteOption(answer)">
                                        <i class="fa-regular fa-2x fa-circle-xmark"></i>
                                    </button>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                    <button @click="addAnswer" v-if="questionData.question_type !== 'true_or_false'" class="btn btn-outline-primary ms-auto d-block rounded-8">
                        Agregar una opción
                    </button>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="form-group">
                <label for="questionadviceinput">Consejo</label>
                <textarea v-model="questionData.advice" id="questionadviceinput" :rows="5" class="form-control sin-borde rounded-8"></textarea>
            </div>
        </div>
        <div class="row mt-4">
            <div class="form-group">
                <label for="questionexplanationinput">Explicación</label>
                <textarea v-model="questionData.explanation" id="questionexplanationinput" :rows="5" class="form-control sin-borde rounded-8"></textarea>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
            <button class="btn btn-outline-primary px-4 rounded-8" @click="cancelQuestion">
                Cancelar
            </button>

            <button :disabled="!isValid" class="btn custombutton btn-primary rounded-8 ms-2 px-4" @click="saveQuestion">
                Guardar
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ['question', 'editing', 'question_number', 'eliminaQuestionAnswer'],
    data(){
        return {
            questionData: { ...this.question } || {},
            typeQuestion: 'radio',
            isEditing: this.editing || false
        }
    },
    mounted(){
        if (this.questionData.answers.length < 1) {
            this.addInitialAnswers();
        }

        if (this.isEditing) {
            if (this.questionData.question_type === 'multi_choice') {
                this.typeQuestion = 'checkbox';
            }else{
                this.typeQuestion = 'radio';
            }
        }
    },
    computed: {
        isValid(){
            return this.questionData.question_type !== ''
                && this.questionData.question !== ''
                && this.questionData.answer !== ''
                && this.questionData.answers.length > 0;
        }
    },
    methods: {
        addInitialAnswers(){
            let initialAnswers = [];
            if (this.questionData.question_type === 'true_or_false') {
                initialAnswers = [
                    {
                        id: Date.now(),
                        text: 'Verdadero'
                    },
                    {
                        id: Date.now() + 1,
                        text: 'Falso'
                    }
                ];
            }else{
                initialAnswers = [
                    {
                        id: Date.now(),
                        text: 'Respuesta 1'
                    }
                ];
            }
            this.questionData.answers = [ ...initialAnswers ];
        },
        addAnswer(){
            this.questionData.answers.push({
                id: Date.now(),
                text: `Respuesta ${this.questionData.answers.length + 1}`
            })
        },
        onChangeTypeQuestion(addOptions = true){
            this.questionData.answers = [];
            if (this.questionData.question_type === 'multi_choice') {
                this.typeQuestion = 'checkbox';
                this.questionData.answer = [];
            }else{
                this.typeQuestion = 'radio';
                this.questionData.answer = '';
            }

            if (addOptions) {
                this.addInitialAnswers();
            }
        },
        cancelQuestion(){
            this.$emit('onCancel');
        },
        saveQuestion(){
            this.$emit('onSave', this.questionData);
        },
        deleteQuestion(){
            this.$emit('onDelete', this.questionData.id);
        },
        deleteOption(option){
            if (option.question_answer_id) {
                this.eliminaQuestionAnswer?.push(option.question_answer_id);
            }

            if(Array.isArray(this.questionData.answer)){
                const optionIndex = (this.questionData.answer)?.indexOf(option.text);
                if (optionIndex !== -1) {
                    this.questionData.answer.splice(optionIndex, 1);
                }
            }

            this.questionData.answers = this.questionData.answers.filter(opt => opt.id !== option.id);
        }
    }
}
</script>
<style>
    .answercard .card-header{
        background-color: #CBB9FF;
    }

    .answercard .card-body{
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .w-90{
        width: 90%;
    }

    .w-10{
        width: 10%;
    }

    .customradiobutton{
        display: block;
        margin: auto;
        height: 20px;
        width: 20px;
        accent-color: #4000BC;
    }

    .custombutton:disabled{
        background-color: #BCB7D1 !important;
        color: #6B6876 !important;
        border: none !important;
    }

    .answer-action{
        background-color: #E0E2FF4D;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

</style>
